import { Button, Stack } from '@mui/material';

export const CopilotSuggestedActions = ({ actions = [], disabled = false }) => {
  if (!actions.length) return null;

  return (
    <Stack direction="row" flexWrap="wrap" gap={1} sx={{ my: 2 }}>
      {actions.map((action) => (
        <Button
          key={action.label}
          variant="outlined"
          size="small"
          disabled={disabled}
          onClick={action.onClick}
          sx={{
            borderRadius: 999,
            px: 1.5,
            py: 0.75,
            textTransform: 'none',
            bgcolor: 'common.white',
            borderColor: 'primary.light',
            color: 'primary.dark',
            '&:hover': {
              bgcolor: 'secondary.light',
              borderColor: 'primary.main',
            },
          }}
        >
          {action.label}
        </Button>
      ))}
    </Stack>
  );
};
